// extracted by mini-css-extract-plugin
export default {"gridHeader":"Tw2KD","name":"HoPIj","icon":"yqQCH","gridColumnsHeader":"ur4AT"};